/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CustomValidatorService } from '../../../../../../components/form-elements/custom-validator.service';
import { DeliveryCostService } from './delivery-cost.service';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../../../components/toaster/toaster.model';
import { BehaviorSubject, take } from 'rxjs';
import { TranslationService } from '@spartacus/core';
import { DeliveryCost } from './delivery-cost.model';

@Component({
  selector: 'cx-delivery-cost',
  templateUrl: './delivery-cost.component.html',
  styleUrl: './delivery-cost.component.scss',
  standalone: false,
})
export class DeliveryCostComponent {
  isLoading$ = new BehaviorSubject<boolean>(false);
  deliveryCost$ = new BehaviorSubject<DeliveryCost | undefined>(undefined);
  deliveryCostForm: UntypedFormGroup = this.fb.group({
    zipCode: ['', [this.customValidatorService.required()]],
  });

  constructor(
    protected fb: UntypedFormBuilder,
    private customValidatorService: CustomValidatorService,
    private deliveryCostService: DeliveryCostService,
    private toasterSerivce: ToasterService,
    private translationService: TranslationService,
  ) {}

  submit() {
    this.deliveryCostForm.markAllAsTouched();

    if (this.deliveryCostForm.valid) {
      const zipcode = this.deliveryCostForm.get('zipCode')?.value;
      this.isLoading$.next(true);

      const handlerSuccess = (deliveryCost: DeliveryCost) => {
        this.deliveryCost$.next(deliveryCost);
        this.isLoading$.next(false);
      };

      const handlerError = (data: any) => {
        this.translationService
          .translate('generic.error')
          .pipe(take(1))
          .subscribe(message => {
            this.toasterSerivce.init({
              type: TOASTER_TYPE.DANGER,
              content: message,
            });

            this.isLoading$.next(false);
          });
      };

      this.deliveryCostService.getDeliveryCost(zipcode).pipe(take(1)).subscribe({
        next: handlerSuccess,
        error: handlerError,
      });
    }
  }
}
